module.exports = __webpack_public_path__ + "0ed999af04c5f71aec62b81173d39685.jpg";